<template>
    <DetermineEligibility/>
</template>

<script>
// @ is an alias to /src
import DetermineEligibility from '@/components/DetermineEligibility.vue'

export default {
  name: 'eligibility',
  components: {
    DetermineEligibility
  }
}
</script>
<style scoped>
	.other-input {

		.v-input__slot {
			min-height:1px;
		}
	}
</style>